/** Month + year label from an ISO timestamp (e.g. news/projects `updated_at`). */
export function formatNewsMonthYear(iso: string | null | undefined) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { month: "long", year: "numeric" });
}

/** @deprecated Use formatNewsMonthYear (same formatting). */
export const formatProjectMonthYear = formatNewsMonthYear;
